<template>
    <div class="">
        <div>
            <h2>Groups</h2>
        </div>

        <groups-edit
            v-model:show="showGroup"
            :group-prop="selectedGroup"
            :users="users"
            v-on:update:group="updateGroupFromEditModal($event)"
            v-on:create:group="getData()"
        ></groups-edit>

        <!-- Table -->
        <ajax-table :data="data"
                    :headers="headers"
                    v-model:loading="ajaxTable.loading"
                    v-model:search="ajaxTable.search"
                    v-model:sort-by="ajaxTable.sortBy"
                    v-model:sort-desc="ajaxTable.sortDesc"
                    v-model:page="ajaxTable.page"
                    v-model:items-per-page="ajaxTable.itemsPerPage"
                    v-model:page-info="ajaxTable.pageInfo"
                    :exportable="false"
                    @loadData="getData"
                    @rowSelected="showGroupModal"
        >
            <!-- Create Device Profile Template Button Right of Search -->
            <template #search-right>
                <div v-if="permissions.can('edit_groups')"
                     class="self-start flex items-center w-full md:w-auto ml:0 md:ml-2">
                    <green-button @click="createGroup"
                    >
                        <div class="inline-flex">
                            <span class="lnr icon-plus-circle mr-2"></span>
                            <span>Create Group</span>
                        </div>
                    </green-button>
                </div>
            </template>

            <!-- Column 1: Group Name + Description -->
            <template #col-1="props">
                <div    class="flex flex-col items-start justify-center">
                    <span   class="my-1 text-gray-700">
                        {{ props.row.name }}
                    </span>
                    <span   class="my-1 text-gray-500">
                        {{ props.row.description }}
                    </span>
                </div>
            </template>

            <!-- Column 2: Group Users -->
            <template #col-2="props">
                <div class="flex items-start flex-wrap">
                    <div v-for="user in props.row.users">
                        <span class="inline-flex items-center m-1 px-2.5 py-0.5 rounded-md text-md font-medium bg-blue-100 text-blue-800">
                            <svg v-if="getUserAdminStatus(user)"
                                 class="-ml-0.5 mr-1.5 h-2 w-2 text-blue-400" fill="currentColor" viewBox="0 0 8 8">
                                <circle cx="4" cy="4" r="3" />
                            </svg>
                            {{  getUserName(user) }}
                        </span>
                    </div>
                </div>

            </template>

            <!--          TODO: Add in zone listing support? -->
        </ajax-table>
    </div>
</template>

<script>

import axios from "axios"
import {SonicuCoreMixin} from "@/mixins/SonicuCoreMixin";
import {iconNamesMixin} from '@/mixins/IconNamesMixin';
import Pagination from "@/components/Pagination"
import ItemsPerPageSelect from "@/components/ItemsPerPageSelect"
import FloatingInput from "@/components/elements/FloatingInput";
import Select2 from '@/components/elements/select2'
import GreenButton from "@/components/elements/green-button";
import AjaxTable from "@/components/elements/AjaxTable";
import {ajaxTableMixin} from "@/mixins/ajaxTableMixin";
import Loading from "@/components/elements/loading";
import SmallColoredCheck from "@/components/elements/SmallColoredCheck";
import {UrlParamsMixin} from "@/mixins/UrlParamsMixin";
import _isNil from "lodash";
import GroupsEdit from "@/components/Groups/GroupsEdit";

export default {
    name: "GroupsIndex",
    mixins: [SonicuCoreMixin, iconNamesMixin, ajaxTableMixin, UrlParamsMixin],
    components: {
        SmallColoredCheck,
        GroupsEdit,
        Loading, AjaxTable, GreenButton, Pagination, ItemsPerPageSelect, FloatingInput, Select2
    },
    props: {
        users: Object,
        admins: Array,
    },
    data() {
        return {
            data: [],
            headers: [
                {
                    name: 'Group Name',
                    sortBy: 'name',
                    show: 'sm',
                    key: 'name',
                },
                {
                    name: 'Users    (• admin)',
                    sortBy: '',
                    show: 'md',
                    key: 'users',
                },
            ],
            requestNumber: 0,

            // For Modal
            showGroup: false,
            selectedGroup: null,
            selectedGroupIndex: null,
            preLoadGroup: null,
        }
    },
    created() {
        this.ajaxTable.sortBy = 'name'
        this.ajaxTable.sortDesc = true
    },
    mounted() {
        this.preLoadGroup = this.urlParamsGet('group')
    },
    methods: {
        getData() {
            this.ajaxTable.loading = true
            this.requestNumber++
            let params = JSON.parse(JSON.stringify(this.ajaxTable))
            params.requestNumber = this.requestNumber
            axios.get(this.company.buildCompanyApiInternalRoute('groups'),
                {
                    params: params,
                }
            ).then(response => {
                let data = response.data;
                if (data.meta.requestNumber !== `${this.requestNumber}`) {
                    return
                }
                this.ajaxUpdateTableData(data); // This sends the data to the mixin for AjaxTable

                this.data = !_.isNil(data.data) ? data.data : [];

                if(this.preLoadGroup){
                    let selectedGroupId = this.preLoadGroup;
                    let selectedGroupIndex = _.findIndex(this.data, function(groupObj) {
                        return groupObj.id === parseInt(selectedGroupId);
                    });
                    if(!_.isNil(selectedGroupIndex) && selectedGroupIndex >= 0){
                        this.showGroupModal(selectedGroupIndex);
                    } else {
                        console.log('removing unfound group');
                        this.urlParamsRemove('group');
                    }
                }
            }).catch(error => {
                console.log(error)
            }).then(() => {
                this.ajaxTable.loading = false
            })
        },
        showGroupModal(rowIndex) {
            this.selectedGroup = this.data[rowIndex];
            this.showGroup = true;
            this.selectedGroupIndex = rowIndex;
            this.urlParamsStore('group', this.data[rowIndex].id)
        },
        createGroup(){
            this.selectedGroup = {
                'name': '',
                'id': null,
                'description': '',
                'users': {}
            };
            this.showGroup = true;
            this.selectedGroupIndex = 0;
        },
        getUserName(userId){
            if(this.users.hasOwnProperty(userId)){
                return this.users[userId];
            }
            return null;
        },
        getUserAdminStatus(userId){
            return this.admins.includes(userId);
        },
        updateGroupFromEditModal(foo){
          this.data[this.selectedGroupIndex] = foo
        }
    },
    computed: {},
    watch: {
        showGroup(val) {
            if (!val) {
                this.urlParamsRemove('group')
            }
        }
    },
}
</script>

<style scoped>

</style>